module.exports = __webpack_public_path__ + "static/media/gardeners-world-background-x2048.a7133b69.jpg";